module.exports = __webpack_public_path__ + "static/left-flower-e42a9daea1fea6635839ccf442884f7c.png";